import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconH2 = /*@__PURE__*/ proxyCustomElement(class WppIconH2 extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-h2", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { d: "M3.5 4.5C3.5 4.08579 3.16421 3.75 2.75 3.75C2.33579 3.75 2 4.08579 2 4.5V15.5C2 15.9142 2.33579 16.25 2.75 16.25C3.16421 16.25 3.5 15.9142 3.5 15.5V10.5H8.5V15.5C8.5 15.9142 8.83579 16.25 9.25 16.25C9.66421 16.25 10 15.9142 10 15.5V4.5C10 4.08579 9.66421 3.75 9.25 3.75C8.83579 3.75 8.5 4.08579 8.5 4.5V9H3.5V4.5ZM14.75 5.25C13.4578 5.25 12.5 6.37402 12.5 7.5C12.5 7.91421 12.1642 8.25 11.75 8.25C11.3358 8.25 11 7.91421 11 7.5C11 5.62598 12.5513 3.75 14.75 3.75C16.1527 3.75 17.225 4.54308 17.7225 5.66463C18.2133 6.77098 18.1329 8.15287 17.3931 9.38587C17.0081 10.0276 16.4347 10.5441 15.8663 10.9916C15.6005 11.2009 15.3209 11.4061 15.0496 11.6053L14.9835 11.6538C14.6876 11.8712 14.4006 12.0833 14.1254 12.3039C13.2332 13.0192 12.5563 13.7528 12.331 14.75H17.25C17.6642 14.75 18 15.0858 18 15.5C18 15.9142 17.6642 16.25 17.25 16.25H11.5C11.0858 16.25 10.75 15.9142 10.75 15.5C10.75 13.4013 11.9765 12.1043 13.1871 11.1336C13.4901 10.8907 13.8007 10.6614 14.0956 10.4448L14.1577 10.3993C14.4335 10.1967 14.6934 10.0059 14.9384 9.81304C15.4715 9.39335 15.8669 9.01409 16.1069 8.61413C16.6171 7.76379 16.6276 6.89569 16.3514 6.27287C16.0818 5.66525 15.5292 5.25 14.75 5.25Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-h2-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-h2", "wpp-icon-h2-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-h2-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-h2-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconH2);
      }
      break;
  } });
}

export { WppIconH2 as W, defineCustomElement as d };
